import React from 'react';
const ailywarner = "/images/clients/AilyWarner.webp";
const NikaAlexey = "/images/clients/NikaAlexey.webp"
const Test2 = () => {
  return (
    <div className="text-center rounded-lg px-4 py-8">
      <h2 className="dark-header text-left mb-8">What our clients say</h2>

      <div className="flex flex-col md:flex-row gap-8 items-stretch">
        {/* Testimonial 1 */}
        <div className="flex-1 flex flex-col justify-between border border-[#eee] rounded-xl p-6">
          <p className="text-[#10c9c0] mb-4 text-[20px] md:text-[25px] leading-relaxed">
            “Again thank you, honestly amazing job, <br />
            we are so very happy.<br />
            I think 3 months is excellent from 1st contact to keys”
          </p>
          <div className="flex justify-center items-center gap-3 mt-4">
            <div className="w-[3rem] h-[3rem]">
              <img src={ailywarner} className="rounded-full w-full h-full" alt="AKIYA2.0 clients" />
            </div>
            <p className="font-[300]">Aily and Warner Lamb</p>
          </div>
        </div>

        {/* Testimonial 2 */}
        <div className="flex-1 flex flex-col justify-between border border-[#eee] rounded-xl p-6">
          <p className="text-[#10c9c0] mb-4 text-[20px] md:text-[25px] leading-relaxed">
            “A huge thank you!<br />
            The whole process went so smoothly,<br />
            professionally, quickly and thoroughly!<br />
            In 1.5 months we proudly own our<br />
            historic dream home!”
          </p>
          <div className="flex justify-center items-center gap-3 mt-4">
            <div className="w-[3rem] h-[3rem]">
              <img src={NikaAlexey} className="rounded-full w-full h-full" alt="AKIYA2.0 clients" />
            </div>
            <p className="font-[300]">Nika and Alexey Plit</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Test2;